module.exports = __webpack_public_path__ + "img/15-threeImg.7376f65e.png";